export default class DashboardCumulativeData {
    constructor(description, number, best, worst) {
        this._description = description;
        this._number = number;
        this._best = best;
        this._worst = worst;
    }
    get description() {
        return this._description;
    }

    get number() {
        return this._number;
    }
    
    get best() {
        return this._best;
    }

    get worst() {
        return this._worst;
    }
}
